/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { settlingin_PlanLabelDTO } from './settlingin_PlanLabelDTO';
export type settlingin_PlanResponse = {
    billing_amount?: number;
    billing_mode?: string;
    blocking_count?: number;
    blocking_item?: settlingin_PlanResponse.blocking_item;
    child_avatar_url?: string;
    child_firstname?: string;
    child_id?: string;
    child_lastname?: string;
    childcare_id?: string;
    childcare_name?: string;
    comment?: string;
    /**
     * CompletionRecordedBy is the staff user id that recorded the completion (#962).
     */
    completion_recorded_by?: string;
    contract_id?: string;
    created_at?: string;
    created_by?: string;
    date_agreed?: boolean;
    /**
     * ST-3/S11 list enrichment. Populated by the list endpoint; additive and optional,
     * so existing consumers of this response are unaffected.
     */
    derived_status?: settlingin_PlanResponse.derived_status;
    end_date?: string;
    group_id?: string;
    group_name?: string;
    id?: string;
    info_confirmed?: boolean;
    info_sent?: boolean;
    is_billed?: boolean;
    labels?: Array<settlingin_PlanLabelDTO>;
    last_activity_at?: string;
    missing_actual_count?: number;
    org_id?: string;
    progress_day_count?: number;
    responsible_firstname?: string;
    responsible_lastname?: string;
    scheduled_day_count?: number;
    settling_in_completed?: boolean;
    /**
     * SignOffChannel is the surface that recorded it: "admin" | "app" (#622).
     */
    sign_off_channel?: settlingin_PlanResponse.sign_off_channel;
    sign_off_contact?: boolean;
    sign_off_contact_id?: string;
    sign_off_date?: string;
    /**
     * SignOffRecordedBy is the staff user id that recorded the sign-off (ST-5/S15).
     */
    sign_off_recorded_by?: string;
    start_date?: string;
    subsidy_billing_choice?: string;
    tracked_day_count?: number;
    updated_at?: string;
    version?: number;
};
export namespace settlingin_PlanResponse {
    export enum blocking_item {
        MISSING_ACTUALS = 'missing_actuals',
        AWAITING_COMPLETION = 'awaiting_completion',
        AWAITING_SIGN_OFF = 'awaiting_sign_off',
        NONE = 'none',
    }
    /**
     * ST-3/S11 list enrichment. Populated by the list endpoint; additive and optional,
     * so existing consumers of this response are unaffected.
     */
    export enum derived_status {
        PLANNED = 'planned',
        RUNNING = 'running',
        NEEDS_ATTENTION = 'needs_attention',
        COMPLETED = 'completed',
        SIGNED_OFF = 'signed_off',
        BILLED = 'billed',
    }
    /**
     * SignOffChannel is the surface that recorded it: "admin" | "app" (#622).
     */
    export enum sign_off_channel {
        ADMIN = 'admin',
        APP = 'app',
    }
}

